import { makeAutoObservable, runInAction } from 'mobx';
import {
  IncomeReports,
  IncomeReportParams,
} from 'src/@types/Choqorak/MainTables/Income/IncomeReport';
import agent from 'src/api/agent';
export default class IncomeReportStore {
  openDialog = false;

  IncomeReportRegistry = new Map<number, IncomeReports>();

  editMode = false; //When click on edit button

  selectedIncomeReport: IncomeReports | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get IncomeReportList() {
    return Array.from(this.IncomeReportRegistry.values());
  }

  setIncomeReportList = (IncomeReport: IncomeReports) => {
    this.IncomeReportRegistry.set(IncomeReport.id!, IncomeReport);
  };

  //Pagination
  loadIncomeReport = async (params: IncomeReportParams) => {
    // this.IncomeReportRegistry.clear();
    try {
      const result = await agent.IncomeReport.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setIncomeReportList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  IncomeReportSearch = async (params: IncomeReportParams) => {
    //this.IncomeReportRegistry.clear();
    this.loadIncomeReport(params);
  };

  getIncomeReportFromRegistry = (id: number) => {
    let IncomeReport = this.IncomeReportRegistry.get(id);
    if (IncomeReport) {
      this.editMode = true;
      this.selectedIncomeReport = IncomeReport;
    }
  };

  clearSelectedIncomeReport = () => {
    this.editMode = false;
    this.selectedIncomeReport = undefined;
  };

  deleteIncomeReport = async (id: number, remark?: string) => {
   
      await agent.IncomeReport.delete(id, remark!);
      runInAction(() => {
        this.IncomeReportRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createIncomeReport = async (IncomeReport: IncomeReports) => {
  
      await agent.IncomeReport.create(IncomeReport);
      runInAction(() => {
        this.loadIncomeReport({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedIncomeReport();
      });
    
  };

  updateIncomeReport = async (IncomeReport: IncomeReports) => {
   
      await agent.IncomeReport.update(IncomeReport);

      runInAction(() => {
        this.loadIncomeReport({ pageIndex: 0, pageSize: 5 });
        this.IncomeReportRegistry.delete(IncomeReport.id!);
        this.IncomeReportRegistry.set(IncomeReport.id!, IncomeReport);
        this.clearSelectedIncomeReport();
      });
    
  };
}
